"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detachReact = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var SlateEditor_1 = __importDefault(require("./SlateEditor"));
var ErrorBoundary_1 = require("./ErrorBoundary");
var PromptContext_1 = require("Prompt/PromptContext");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DIProvider_1 = require("DIProvider/DIProvider");
function attachReact(elem, router, saver, loader, initialState, errorRecorder, showImagePicker, configuration, cursorValidator, usingFeature, conversionElem, di, blockStore, brandStore, commentThreadStore, uploadStore, videoEmbedUrlGenerator, projectStore, promptOrchestrator, modal, blockList, editorBlockIdStore) {
    var MaybeOverlayProvider = function (_a) {
        var children = _a.children;
        return blockStore.isSavedBlock ? react_1.default.createElement(kaleidoscope_1.AngularOverlayProvider, null, children) : children;
    };
    react_dom_1.default.render(react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
        react_1.default.createElement(MaybeOverlayProvider, null,
            react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { errorRecorder: errorRecorder, modal: modal },
                react_1.default.createElement(PromptContext_1.PromptProvider, { value: { promptOrchestrator: promptOrchestrator } },
                    react_1.default.createElement(SlateEditor_1.default, { saver: saver, router: router, loader: loader, initialState: initialState, editorElem: elem, showImagePicker: showImagePicker, configuration: configuration, cursorValidator: cursorValidator, usingFeature: usingFeature, conversionElem: conversionElem, di: di, blockStore: blockStore, brandStore: brandStore, commentThreadStore: commentThreadStore, uploadStore: uploadStore, videoEmbedUrlGenerator: videoEmbedUrlGenerator, projectStore: projectStore, blockList: blockList, editorBlockIdStore: editorBlockIdStore }))))), elem);
}
exports.default = attachReact;
function detachReact(elem) {
    var unmounted = react_dom_1.default.unmountComponentAtNode(elem);
}
exports.detachReact = detachReact;
